<template>

  <home-header v-if="$user" @search="openSearch = true"/>

  <home-aside v-if="$user"/>

  <main
      :class="
      $user ?
        'rounded-l-xl dark:bg-slate-700 bg-slate-200 shadow-[inset_1px_0px_10px_0px_rgba(0,0,0,.25)]':
        'row-span-2 col-span-3 items-center'
    "
      class="flex flex-col py-10 pl-10 pr-8 overflow-y-scroll overflow-x-auto"
  >
    <router-view :key="$route.path"/>
  </main>

  <home-footer v-if="$user"/>

  <home-search :open="openSearch" @close="openSearch = false" />

  <Toast
      :pt="{
      content: {
        class: 'p-2 border-0 gap-5 items-center'
      },
      detail: {
        class: 'm-0'
      },
      text: {
        class: 'text-xs text-left m-0'
      },
    }"
  />

</template>


<script>

import HomeSearch from "#views/home/search";
import HomeHeader from "#views/home/header";
import HomeAside from "#views/home/aside";
import HomeFooter from "#views/home/footer";

export default {
  name: "App",
  components: {
    HomeSearch,
    HomeHeader,
    HomeAside,
    HomeFooter
  },
  data() {
    return {
      openSearch: false,
    };
  }
};
</script>
